export const forBusiness_creative_convert_1 = [
	{
		icon: '✅',
		subtitle: 'convertData_block1_subtitle1',
	},
	{
		icon: '✅',
		subtitle: 'convertData_block1_subtitle2',
	},
	{
		icon: '✅',
		subtitle: 'convertData_block1_subtitle3',
	},
];

export const convert_1AboveList = [
	{
		text: 'convertData_block1_textAbove_text1',
	},
];

export const forBusiness_creative_convert_2 = [
	{
		icon: '✅',
		subtitle: 'convertData_block2_subtitle1',
	},
	{
		icon: '✅',
		subtitle: 'convertData_block2_subtitle2',
	},
	{
		icon: '✅',
		subtitle: 'convertData_block2_subtitle3',
	},
];

export const convert_2AboveList = [
	{
		text: 'convertData_block2_textAbove_text1',
	},
];
